export default function getRansomName( delimiter: string = " "): string {
    let name = `${getRandom( firstNames() )}${ delimiter }${getRandom( secondNames() )}`
    return name
}
const getRandom = (arr: string[]) : string => {
    return arr[Math.floor(Math.random() * arr.length)]
}
export const firstNames = (): string[] => {
    return [
        "Жуткий",
        "Незаметный",
        "Отдохнувший",
        "Жалкий",
        "Красивый",
        "Сломаный",
        "Второй",
        "Оный",
        "Капитальный",
        "Мужской",
        "Застрелянный",
        "Утраченный",
        "Пафосный",
        "Скрипучий",
        "Фарфоровый",
        "Магический",
        "Воспалённый",
        "Контробандный",
        "Решительный",
        "Малый",
        "Встревоженный",
        "Бренный",
        "Фторорвый",
        "Бессмертный",
        "Оккультный",
        "Вспыхнувший",
        "Ветренный",
        "Рьяный",
        "Буйный",
        "Мокрый",
        "Станционный",
        "Взбесившийся",
        "Годовалый",
    ]
}

export const secondNames = (): string[] => {
    return [ 
        "Малах",
        "Боров",
        "Умбриель",
        "Калибан",
        "Шерстяк",
        "Волос",
        "Мафусаил",
        "Вепрь",
        "Символ",
        "Валах",
        "Назгул",
        "Тор",
        "Соломон",
        "Пушкарь",
        "Золотарь",
        "Золотник",
        "Мазур",
        "Кипчак",
        "Фанфарон",
        "Фальстаф",
        "Панегирик",
        "Череп",
        "Единорог",
        "Отпечаток",
        "Панини",
        "Ходок",
        "Именинник",
        "Буцефал",
        "Мизинец",
        "Портной", 
        "Шарк", 
        "Фарамир", 
        "Джин", 
        "Амулет",
        "Царь",
        "Вавилон",
        "Пёс",
    ]
}